import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsultantsService } from '../../shared/services/consultants.service';
import { AuditService } from '../../shared/services/audit.service';
import { AuditFormComponent } from '../../case/audit-form/audit-form.component';
import { faHistory} from '@fortawesome/pro-light-svg-icons';
import { ComparerService } from '../../shared/utility/comparer';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/shared/services/toast.service';


@Component({
  selector: 'app-consultant-details',
  templateUrl: './consultant-details.component.html',
  styleUrls: ['./consultant-details.component.scss']
})
export class ConsultantDetailsComponent implements OnInit {

  @Input() consultantId?: number;
  newConsultant: boolean = true;

  updatingConsultant: boolean = false;
  faHistory= faHistory;

  consultantDetails = this.fb.group({
    id: [],
    name:  [],
    emailAddress: [],
    postcode: [],
    borough: [],
    numberDaysWorkedPerWeek: [],
    daysOfTheWeekWorked: [],
    milesWillingToTravel: [],
    phoneNumber: [],
    fees: [],
    active: [],
    individualStatusId: new UntypedFormControl({ value: null, disabled: true })
  }, { });

  initialForm = this.fb.group({
    id: [],
    name:  [],
    emailAddress: [],
    postcode: [],
    borough: [],
    numberDaysWorkedPerWeek: [],
    daysOfTheWeekWorked: [],
    milesWillingToTravel: [],
    phoneNumber: [],
    fees: [],
    active: [],
    individualStatusId: new UntypedFormControl({ value: null, disabled: true })
  }, { });

  constructor(private fb: UntypedFormBuilder,
              private consultantsService: ConsultantsService,
              private toastService: ToastService,
              private auditService: AuditService,
              private comp: ComparerService,
              public activeModal: NgbActiveModal,
              private modalService: ModalService) {

  }

  ngOnInit(): void {
      if(this.consultantId !== undefined && this.consultantId !== null){
        this.newConsultant = false;

        this.consultantsService.consultantDetails(this.consultantId).subscribe(result => {
          this.consultantDetails.patchValue(result);
          this.initialForm.patchValue(result);
        });
      }
      else{
          this.consultantDetails.controls['active'].patchValue(true);
      }
  }

  saveConsultant(){
    if(this.comp.objectsDifferent(this.initialForm.value, this.consultantDetails.value))
    {
      this.auditService.auditFormItem('ConsultantDetails', this.initialForm.value, this.consultantDetails.value, this.consultantId).subscribe((response : any) => {
        this.doSave();
      });
    }
    else{
      this.doSave();
    }
  }

  doSave(){

    this.updatingConsultant = true;

    this.consultantsService.updateConsultant(this.consultantId, this.consultantDetails.value).subscribe(response => {


      this.activeModal.close(true);
      this.updatingConsultant = false;

      }, error => {

        var errorMessage = "Consultant Update Failed";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

        this.updatingConsultant = false;
        this.toastService.error(errorMessage);


      });
  }

  addConsultant(){


    this.consultantsService.addConsultant(this.consultantDetails.value).subscribe(response => {

      this.activeModal.close(true);

      }, error => {


        var errorMessage = "Consultant Creation Failed";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

        this.toastService.error(errorMessage);


      });
  }


  openAuditForForm(){

    const modalRef = this.modalService.openWithOptions(AuditFormComponent, {size: 'xl'});
    modalRef.componentInstance.itemId = this.consultantId;
    modalRef.componentInstance.formName = "ConsultantDetails";

  }

}
